import { render } from "./BasePre.vue?vue&type=template&id=b28fc858&scoped=true&ts=true"
import script from "./BasePre.vue?vue&type=script&lang=ts"
export * from "./BasePre.vue?vue&type=script&lang=ts"

import "./BasePre.vue?vue&type=style&index=0&id=b28fc858&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b28fc858"]])

export default __exports__